






































































































































































































































































































































import Component from 'vue-class-component';
import Vue from 'vue';
import SitesAvpStatsPayoutCriteria from './sites-avp-stats-payout-criteria.vue';
import { ISitesStatsCriteria } from './sites-stats-criteria.interface';
import * as ent from '@/entities';
import statsApi from '@/api/stats.api';
import { IListItem, GroupBy, IDictionary, AccountRole } from '@/entities';
import {formatDate, parseDate} from '@/utils';
import { MasterPage } from '@/components/base/master/master-page';

interface ISiteStatsTypeInfoPayout extends ent.ISiteStatsTypeInfo {
    payout: boolean;
}

@Component({
    components: {
        'site-avp-stats-payout-criteria': SitesAvpStatsPayoutCriteria
    }
})
export default class SitesAvpStatsPayout extends MasterPage {
    public siteTypes: IListItem[] = null;

    public printVersion = false;

    public items: ent.ISiteStatsPayoutItemModel[] = null;
    public overall: ent.ISiteStatsOverallModel = null;
    public typeInfos: ISiteStatsTypeInfoPayout[] = null;
    public useApproveSale: boolean = false;
    public hasBonus: boolean = false;

    public loading: boolean = false;
    public criteria: ISitesStatsCriteria = null;
    public newFilter: any = null;
    public groupByVal = GroupBy.Agent;

    public criteriaStr: string = '';
    public criteriaStrHolder: string = '';

    get defaultSort(): ent.ISort {
        switch (this.groupBy) {
            case GroupBy.Date:
            case GroupBy.Detail:
                return {
                    field: 'date',
                    asc: false
                };
            case GroupBy.Company:
                return {
                    field: 'officeName',
                    asc: true
                };
            case GroupBy.Agent:
                return {
                    field: 'agent',
                    asc: true
                };
            default:
                return {
                    field: 'raws',
                    asc: true
                };
        }
    }

    get groupBy() {
        return this.groupByVal;
    }

    get dateColVisible() {
        switch (this.groupBy) {
            case GroupBy.Date:
            case GroupBy.Detail:
                return true;
            default:
                return false;
        }
    }

    get officeColVisible() {
        switch (this.groupBy) {
            case GroupBy.Company:
            case GroupBy.Agent:
            case GroupBy.Detail:
                return true;
            default:
                return false;
        }
    }

    get agentColVisible() {
        switch (this.groupBy) {
            case GroupBy.Agent:
            case GroupBy.Detail:
                return true;
            default:
                return false;
        }
    }

    get bonusColVisible() {
        return this.hasBonus;
    }

    get leftColumsCount() {
        return (
            (this.dateColVisible ? 1 : 0) +
            (this.officeColVisible ? 1 : 0) +
            (this.agentColVisible ? 1 : 0)
        );
    }

    get totalColumsCount() {
        return (
            1 + // index
            this.leftColumsCount + // date, agent, office
            (this.typeInfos ? this.typeInfos.length : 0) +
            2 + // sales, payout
            (this.hasBonus ? 2 : 0) // bonus, bonusRatio
        );
    }

    get empty(): boolean {
        return !this.items || !this.items.length;
    }

    get bonusRatioTotal(): number {
        const sales = this.sumBy((x) => x.sales);
        const bonusSales = this.sumBy((x) => x.bonusSales);
        return sales > 0 ? (bonusSales * 100) / sales : 100;
    }

    public sumBy(predicate: (a: ent.ISiteStatsPayoutItemModel) => number) {
        if (!this.items || !this.items.length) {
            return 0;
        }
        return this.items.reduce((a, x) => {
            const value = predicate(x);
            return a + value;
        }, 0);
    }

    public range(count: number): number[] {
        const foo = [];
        for (let i = 0; i < count; i++) {
            foo.push(i);
        }
        return foo;
    }

    public criteriaChange(body: ISitesStatsCriteria) {
        this.criteria = body;
        this.search();
    }

    public criteriaStrChange(criteriaStr: string) {
        this.criteriaStrHolder = criteriaStr;
    }

    public async search() {
        if (!this.criteria) {
            this.items = null;
            this.criteriaStr = '';
            return;
        }
        if (this.loading){
          return;
        }
        this.loading = true;
        // this.items = null;

        try {
            if (this.groupByVal !== this.criteria.groupBy) {
                this.groupByVal = this.criteria.groupBy;
                this.sortChange(this.defaultSort);
            }
            const model = await statsApi.sitesAvpPayout({
                groupBy: this.criteria.groupBy,
                siteId: this.criteria.siteId,
                typeId: this.criteria.typeId,
                avp: this.criteria.avp,
                companyId: this.criteria.companyId,
                agentId: this.criteria.agentId,
                start: this.criteria.start,
                end: this.criteria.end,
                // sortField: this.sort.field,
                // sortAsc: this.sort.asc,
                ...this.pageSortParams()
            });
            this.items = model.page.items;
            this.overall = model.overall;
            this.typeInfos = this.mapTypeInfos(model.types);
            this.hasBonus = model.hasBonus;
            this.useApproveSale = model.useApproveSale;
            this.typeInfos = this.mapTypeInfos(model.types);
            const mapped: IListItem[] = model.types
                .filter((x) => !x.bonus)
                .map((x) => {
                    return { heading: x.typename, value: x.typeId };
                });
            this.siteTypes = mapped;
            this.criteriaStr = this.criteriaStrHolder;
            if (model.page.total !== null) {
              this.total = model.page.total;
            }
        } finally {
            this.loading = false;
        }
    }

    public getDateQuery(item: ent.ISiteStatsItemModel) {
        this.newFilter = {
            groupBy: GroupBy.Company,
            dateRange: {
                start: parseDate(item.date),
                end: parseDate(item.date)
            }
        };
    }

    public getOfficeQuery(item: ent.ISiteStatsItemModel) {
        this.newFilter = {
            groupBy: GroupBy.Agent,
            companyId: item.companyId
        };
    }

    public getAgentQuery(item: ent.ISiteStatsItemModel) {
        this.newFilter = {
            groupBy: GroupBy.Detail,
            agentId: item.agentId
        };
    }

    private togglePrintVersion() {
        this.printVersion = !this.printVersion;
    }

    private mapTypeInfos(
        src: ent.ISiteStatsTypeInfo[]
    ): ISiteStatsTypeInfoPayout[] {
        const res = [];
        for (let item of src) {
            res.push({
                ...item,
                id: item.id,
                payout: false
            });
            if (this.useApproveSale && !item.bonus){
              //do not push
            } else {
              res.push({ ...item, id: item.id + '_payout', payout: true });
            }
        }
        return res;
    }
}
